import styled from "styled-components";
import { NavLink } from "react-router-dom";

export const ProfileLink = styled(NavLink)`
  display: flex;
  justify-content: end;
  color: white;
  align-items: center;
  padding: 10px;
  &:hover {
    color: #ccc;
  }
`;

export const ProfileLinkIcon = styled("span")`
  width: 25%;
  text-align: center;
`;
export const ProfileLinkTitle = styled("p")`
  width: 65%;
  display: inline-block;
  margin: 0;
`;

export const ContainerUserInf = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: white;
`;
export const UserImage = styled("img")`
  border-radius: var(--border-radius-rounded);
  width: 100px;
  height: 100px;
`;

export const WalletIconContainer = styled("span")`
  display: flex;
  justify-content: center;
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.2);
  box-shadow: inset 2.50406px 2.50406px 5.00813px #ffffff,
    inset 0px 2.50406px 110.179px rgba(255, 255, 255, 0.45),
    inset 0px -2.50406px 10.0163px rgba(255, 255, 255, 0.5),
    inset 0px 2.50406px 10.0163px rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(5.00813px);
  border-radius: 68px;
  min-width: 80px;
  svg {
    color: var(--secondary-color);
  }
`;
